import { useEffect, useState } from "react";

const useIsBelow651 = () => {
  const [isBelow651, setIsBelow651] = useState<boolean>(
    typeof window !== "undefined" ? window.innerWidth < 651 : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsBelow651(window.innerWidth < 651);
    };

    window.addEventListener("resize", handleResize);

    // Run once on mount to be safe
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isBelow651;
};

export default useIsBelow651;
